import React, { useState } from "react";
import "../form.css";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  FormGroup,
  Typography,
  Modal,
  Snackbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Form, Input } from "antd";
import Swal from "sweetalert2";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  CalendarOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import useAxiosInstance from "../helpers/useAxiosInstance";
import { message} from 'antd';


const { TextArea } = Input;

const AddClient = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const path = window.location.pathname;
  const lastSegment = path.split("/")?.filter(Boolean)?.pop()?.toUpperCase();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const axiosInstance = useAxiosInstance();
  const [messageApi, contextHolder] = message.useMessage();

  const initialFilters = {
    availability: [],
    sq_ft: [],
    // For Location group - initialized as empty arrays for multi-select
    market: [lastSegment],
    submarket: [],
    city: [],
    state: [],
    zip_code: [],

    // For Units group - initialized as booleans
    studio: false,
    one_bed: false,
    one_bed_with_study: false,
    two_bed: false,
    three_bed: false,
    four_plus_bed: false,
    single_family: false,
    // townhome: false,
    high_rise: false,
    // For Amenities group - initialized as booleans
    yard: false,
    loft: false,
    garage: false,
    study: false,
    desk: false,
    ev_charger: false,
    fireplace: false,
    no_carpet: false,
    tub_shower: false,
    industrial: false,
    concrete_floors: false,
    // furnished: false,
    high_ceilings: false,
    terrace: false,
    roof_terrace: false,
    floor_to_ceiling_windows: false,
    concierge: false,
    // washer_dryer_in_unit: false,
    // washer_dryer_connections: false,
    // washer_dryer_in_building: false,

    year_built: [1990],
    year_renovated: [],
    // number_floors: [],
    google_rating: [3.7, 5],
    price_range: [0, 5000],
    // admin_fee: [],
    // application_fee: [],
    send: [],
    escort: [],
    bonus: [],

    shape: [],
    category: null,
    one_and_a_half_bath: false,
    studio_price: [],
    one_bed_price: [],
    two_bed_price: [],
    three_bed_price: [],
    four_plus_bed_price: [],
    escort_type: "percentage",
    send_type: "percentage",
    min_price: null,
    max_price: null,
  };
  const [modalLoader, setModalLoader] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    month: null,
    bedrooms: [],
    budget: 0,
    sq_ft: 0,
    desired_location: "",
    additional_notes: "",
  });

  const [touchedFields, setTouchedFields] = useState({
    firstName: false,
    lastName: false,
    phone: false,
    email: false,
    month: false,
    bedrooms: false,
    desired_location: false,
    additional_notes: false,
    budget: false,
  });

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    
    if(name === 'month' && type === 'date'){
      setFilters((prev)=>({
         ...prev,
          availability: ["", value]
      }))
    }
    // Handle multiple select
    if (type === "select-multiple") {
      const values = Array.from(
        event.target.selectedOptions,
        (option) => option.value
      );
      setFormValues((prev) => ({
        ...prev,
        [name]: values,
      }));
    } else if (type === "checkbox") {
      setFormValues((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else if (type === "number") {
      setFormValues((prev) => ({
        ...prev,
        budget: parseInt(value),
      }));
      setFilters((prev) => ({
        ...prev,
        price_range: [0, parseInt(value)],
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Mark field as touched
    setTouchedFields((prev) => ({
      ...prev,
      [name]: true,
    }));

    if (name === "bedrooms") {
      const selectedBedrooms = Array.isArray(value) ? value : [];

      setFilters((prev) => ({
        ...prev,
        studio: selectedBedrooms.includes("Studio"),
        // "1 Bed w/ Study" on the form also selects the 1 Bed filter in Sidekick
        one_bed:
          selectedBedrooms.includes("1 Bed") ||
          selectedBedrooms.includes("1 Bed w/ Study"),
        one_bed_with_study: false,
        two_bed: selectedBedrooms.includes("2 Bed"),
        three_bed: selectedBedrooms.includes("3 Bed"),
        four_plus_bed: selectedBedrooms.includes("4+ Bed"),
      }));
    }
  
  };

  const handleSliderChange = (event, newValue, name) => {
    if (name === "sq_ft") {
      setFormValues((prev) => ({
        ...prev,
        [name]: newValue,
      }));

      setFilters((prev) => ({
        ...prev,
        [name]: [1, newValue],
      }));
    } else if (name === "price") {
      setFormValues((prev) => ({
        ...prev,
        [name]: {
          min: newValue[0],
          max: newValue[1],
        },
      }));

      setFilters((prev) => ({
        ...prev,
        price_range: [newValue[0], parseInt(newValue[1])],
      }));

      setFilters((prev) => ({
        ...prev,
        budget: newValue[1],
      }));

      setFilters((prev) => ({
        ...prev,
        min_price: newValue[0],
        max_price: newValue[1],
      }));
    }
    console.log(filters);
  };
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${parseInt(month)}/${parseInt(day)}`;
  };

  // const formattedBedrooms = (bedrooms) => {
  //   if (!bedrooms || bedrooms.length === 0) return "";

  //   return bedrooms
  //     .map((bedroom) => {
  //       const lower = bedroom.toLowerCase();
  //       if (lower === "studio") return "studio";
  //       if (lower === "1 bed w/ study") return "1 bed w/ study";
  //       const num = bedroom.split(" ")[0];
  //       return `${num} bed`;
  //     })
  //     .join(" or ");
  // };

  const BEDROOM_ORDER = ["studio", "1 bed", "1 bed w/ study", "2 bed", "3 bed", "4+ Bed"];

const formattedBedrooms = (bedrooms) => {
  if (!bedrooms || bedrooms.length === 0) return "";

  // Normalize and sort by fixed order
  const normalized = bedrooms.map((bedroom) => {
    const lower = bedroom.toLowerCase();
    if (lower === "studio") return "studio";
    if (lower === "1 bed w/ study") return "1 bed w/ study";
    const num = bedroom.split(" ")[0];
    return `${num} bed`;
  });

  const sorted = normalized.sort(
    (a, b) => BEDROOM_ORDER.indexOf(a) - BEDROOM_ORDER.indexOf(b)
  );

  // Format based on count
  if (sorted.length === 1) return sorted[0];
  if (sorted.length === 2) return `${sorted[0]} or ${sorted[1]}`;

  // 3 or more: comma-separated with "or" before last
  const allButLast = sorted.slice(0, -1).join(", ");
  return `${allButLast}, or ${sorted[sorted.length - 1]}`;
};


  const notesGenerate = () => {
    const bedrooms = formattedBedrooms(formValues?.bedrooms);

    const content = `Hey ${
      formValues?.firstName
    }! This is Aubree with Apartment Hunters. Thanks so much for getting in touch.<br><br>I see we're looking for a ${bedrooms}, $${
      formValues?.budget
    } max, for a ${formatDate(formValues?.month)} move in, around the ${
      formValues?.desired_location
    } areas. Does that all sound correct?`;

    return content;
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      // setModalLoader(true);

      const trimmedValues = {
        ...formValues,
        firstName: formValues.firstName?.trim(),
        lastName: formValues.lastName?.trim(),
        phone: formValues.phone?.trim(),
        email: formValues.email?.trim(),
        desired_location: formValues.desired_location?.trim(),
        additional_notes: formValues.additional_notes?.trim(),
      };

      const isValid =
        trimmedValues.firstName?.length >= 3 &&
        trimmedValues.lastName?.length >= 3 &&
        trimmedValues.phone?.length >= 10 &&
        trimmedValues.email?.length >= 3 &&
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          trimmedValues.email
        ) &&
        trimmedValues.month &&
        Array.isArray(trimmedValues.bedrooms) &&
        trimmedValues.bedrooms.length > 0 &&
        trimmedValues.budget &&
        trimmedValues.desired_location &&
        trimmedValues.additional_notes;

      if (!isValid) {
        // alert("Please fill in all required fields correctly.");
      messageApi.open({
      type: 'warning',
      content: 'Please fill in all required fields correctly.',
    });
        setLoading(false);
        return;
      }
      setLoading(true);

      const data = {
        ...formValues,
        firstName: trimmedValues.firstName,
        lastName: trimmedValues.lastName,
        phone: trimmedValues.phone,
        email: trimmedValues.email,
        desired_location: trimmedValues.desired_location,
        additional_notes: trimmedValues.additional_notes,
        type: lastSegment.toUpperCase(),
        content: notesGenerate(),
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/addFormData`,
        data
      );

      const client = response?.data?.clients;
      // Build filters from the submitted values and pass them explicitly,
      // instead of reading `filters` state that is stale inside this handler.
      const searchFilters = buildSearchFilters(
        filters,
        client?.no_of_bedrooms ?? formValues.bedrooms,
        client?.budget ?? formValues.budget
      );

      // Save the search right away (no timer) so it can't be lost if the
      // client closes the tab.
      await saveSearch({
        clientId: client?.id,
        name: client?.firstname,
        searchFilters,
        searchId:
          response?.data?.message === "update"
            ? response?.data?.searchId
            : undefined,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setTimeout(() => {
        setSnackbarOpen(false);
        // setModalLoader(false);
        setLoading(false);
      }, 3000);
    }
  };

  // Pure helper: everything it needs comes in as parameters.
  // "1 Bed w/ Study" => 1 Bed filter + Study amenity filter in Sidekick.
  const buildSearchFilters = (baseFilters, selectedBedrooms, budget) => {
    const beds = Array.isArray(selectedBedrooms) ? selectedBedrooms : [];
    const hasStudyUnit = beds.includes("1 Bed w/ Study");
    const maxPrice = parseInt(budget);
    return {
      ...baseFilters,
      google_rating: [3.7, 5],
      studio: beds.includes("Studio"),
      one_bed: beds.includes("1 Bed") || hasStudyUnit,
      one_bed_with_study: false,
      two_bed: beds.includes("2 Bed"),
      three_bed: beds.includes("3 Bed"),
      four_plus_bed: beds.includes("4+ Bed"),
      study: !!(baseFilters?.study || hasStudyUnit),
      ...(Number.isNaN(maxPrice)
        ? {}
        : { price_range: [0, maxPrice], max_price: maxPrice }),
    };
  };

  const showSuccess = () =>
    Swal.fire({
      title: "Success!",
      text: "Thank you! I'll text you soon and look forward to working together.",
      icon: "success",
      showCloseButton: true,
      allowOutsideClick: true,
      confirmButtonText: "Done",
    }).then(() => {
      window.location.href = window.location.href;
    });

  // Creates the saved search, or updates the existing one. If the update is
  // rejected, falls back to creating one so the client always shows up in
  // Sidekick's saved searches.
  const saveSearch = async ({ clientId, name, searchFilters, searchId }) => {
    const base = process.env.REACT_APP_API_URL;
    try {
      if (searchId) {
        try {
          await axiosInstance.put(`${base}/search/${searchId}`, {
            filters: searchFilters,
            client: clientId,
            user: 2,
            searchName: name,
          });
        } catch (updateError) {
          console.error("Search update failed, creating a new one:", updateError);
          await axiosInstance.post(`${base}/searchForm`, {
            filters: searchFilters,
            client: clientId,
            searchName: name,
          });
        }
      } else {
        await axiosInstance.post(`${base}/searchForm`, {
          filters: searchFilters,
          client: clientId,
          searchName: name,
        });
      }
    } catch (error) {
      console.error("Error saving search:", error);
    } finally {
      showSuccess();
    }
  };

  // const isFormValid =
  //   formValues.firstName &&
  //   formValues.firstName.length >= 3 &&
  //   formValues.lastName &&
  //   formValues.lastName.length >= 3 &&
  //   formValues.phone &&
  //   formValues.phone.length >= 10 &&
  //   formValues.email &&
  //   formValues.email.length >= 3 &&
  //   /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]{3,}\.[a-zA-Z]{2,}$/.test(
  //     formValues.email
  //   ) &&
  //   formValues.month &&
  //   formValues.bedrooms.length > 0 &&
  //   formValues.budget &&
  //   // formValues.additional_notes && formValues.firstName.length >= 3 &&
  //   formValues.desired_location &&
  //   formValues.additional_notes &&
  //   formValues.firstName.length >= 3;

  // const isFormValid = useMemo(() => {
  //   return (
  //     formValues.firstName?.trim().length >= 3 &&
  //     formValues.lastName?.trim().length >= 3 &&
  //     formValues.phone?.trim().length >= 10 &&
  //     formValues.email?.trim().length >= 3 &&
  //     /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]{3,}\.[a-zA-Z]{2,}$/.test(
  //       formValues.email?.trim()
  //     ) &&
  //     formValues.month &&
  //     Array.isArray(formValues.bedrooms) &&
  //     formValues.bedrooms.length > 0 &&
  //     formValues.budget &&
  //     formValues.desired_location?.trim() &&
  //     formValues.additional_notes?.trim()
  //   );
  // }, [formValues]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const bedrooms = ["Studio", "1 Bed", "1 Bed w/ Study", "2 Bed", "3 Bed", "4+ Bed"];

  const features = [
    {
      value: "Yard",
      key: "yard",
    },
    {
      value: "Garage",
      key: "garage",
    },
    {
      value: "Study",
      key: "study",
    },
    {
      value: "Desk",
      key: "desk",
    },
    {
      value: "EV Charger",
      key: "ev_charger",
    },
    {
      value: "Fireplace",
      key: "fireplace",
    },
    {
      value: "No Carpet",
      key: "no_carpet",
    },
    {
      value: "Tub Shower",
      key: "tub_shower",
    },
    {
      value: "Industrial",
      key: "industrial",
    },
    {
      value: "Concrete Floors",
      key: "concrete_floors",
    },
    // {
    //   value: "Furnished",
    //   key: "furnished",
    // },
    {
      value: "High Ceilings",
      key: "high_ceilings",
    },
    {
      value: "Terrace",
      key: "terrace",
    },
    {
      value: "Roof Terrace",
      key: "roof_terrace",
    },
    {
      value: "Floor To Ceiling Windows",
      key: "floor_to_ceiling_windows",
    },
    {
      value: "Concierge",
      key: "concierge",
    },
    // {
    //   value: "Washer Dryer In Unit",
    //   key: "washer_dryer_in_unit",
    // },
    // {
    //   value: "Washer Dryer Connections",
    //   key: "washer_dryer_connections",
    // },
    // {
    //   value: "Washer Dryer In Building",
    //   key: "washer_dryer_in_building",
    // },
    {
      value: "1.5 Bath",
      key: "one_and_a_half_bath",
    },
    {
      value: "High Rise",
      key: "high_rise",
    },
    // {
    //   value: "Townhome",
    //   key: "townhome",
    // },
    {
      value: "Townhome/Single Family",
      key: "single_family",
    },
  ];

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  return (
    <div
      className="font-playfair"
      style={{
        background: "#eae1d6",
        fontFamily: "'Playfair Display', serif !important",
        color: "#5d6858",
      }}
    >
      {contextHolder}
      <form
        onSubmit={handleSubmit}
        className="md:w-6/12 mx-auto md:mt-0"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <Grid style={{ marginRight: "2rem", marginLeft: "2rem" }}>
          <Box textAlign="center" sx={{ width: "100%" }}>
            <Typography
              variant="h3"
              color="primary"
              mb={3}
              style={{ color: "#5d6858" }}
              sx={{ fontFamily: "'Playfair Display', serif !important" }}
            >
              Contact
            </Typography>
          </Box>

          <div>
            <Grid container spacing={4}>

                <Grid item xs={12} md={6}>

    <Box mb={2}>
      <Typography sx={{ color: "#5d6858" }}>
        My services are completely free! I believe that finding your ideal space
        should be enjoyable, not daunting. Whether you're a first-time buyer,
        renter, or ready to upgrade, I’d love to help you find the perfect home.
      </Typography>
    </Box>

    <Box mb={2}>
      <Typography sx={{ color: "#5d6858" }}>
        Fill out the form below and I’ll reach out asap. Your perfect home is just
        a few clicks away!
      </Typography>
    </Box>
  </Grid>

  {/* RIGHT IMAGE + SIGNATURE */}
 <Grid item xs={12} md={6}>
  <Box display="flex" flexDirection="column" alignItems="flex-end">
    {/* Image */}
    <Box
      sx={{
        width: {
          xs: "90%",
          sm: "90%",
          md: "90%",
          lg: "90%",
          xl: "90%"
        }
      }}
    >
      <Box position="relative" sx={{ aspectRatio: "1 / 1" }}>
        <Box
          position="absolute"
          top={12}
          left={12}
          width="100%"
          height="100%"
          border="1px solid #9ca3af"
          borderRadius="16px"
        />

        <Box
          position="relative"
          width="100%"
          height="100%"
          bgcolor="white"
          borderRadius="16px"
          boxShadow={3}
          zIndex={1}
        >
          <img
            src="aubree2.jpg"
            alt="Aubree Photo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "16px"
            }}
          />
        </Box>
      </Box>
    </Box>

    {/* Signature */}
    <Typography mt={2} sx={{ color: "#5d6858", textAlign: "right" }}>
      - Aubree @ The Realty Influence
    </Typography>
  </Box>
</Grid>



            </Grid>


          </div>

          {/* <Box textAlign="left" sx={{ width: "100%", marginBottom: "10px" }}>
            <Typography
              variant="h7"
              color="primary"
              mb={3}
              style={{ color: "#5d6858" }}
            >
              My services are completely free! I believe that finding your ideal space should be enjoyable, not daunting. Whether you're a first-time buyer, renter, or ready to upgrade, I’d love to help you find the perfect home.
            </Typography>
          </Box>

          <Box textAlign="left" sx={{ width: "100%", marginBottom: "10px" }}>
            <Typography
              variant="h7"
              color="primary"
              mb={3}
              style={{ color: "#5d6858" }}
            >
              Fill out the form below and I’ll reach out asap. Your perfect home
              is just a few clicks away!
            </Typography>
          </Box>
          


              <div className="flex justify-end w-full">
  <div className="w-[50%] p-5 px-5 pb-6 md:p-8 lg:p-6 xl:p-5 relative">
    <div className="relative w-full h-full flex flex-col">
      <div className="absolute top-3 left-3 w-full h-full rounded-2xl border border-gray-400 aspect-square"></div>

      <div className="relative w-full h-full bg-white rounded-2xl shadow-lg z-10 aspect-square">
        <img
          src="aubree2.jpg"
          alt="Aubree Photo"
          className="w-full h-full object-cover rounded-2xl"
        />
      </div>
    </div>
  </div>
</div>

          <Box textAlign="right" sx={{ width: "100%", marginBottom: "10px" }}>
            <Typography
              variant="h7"
              color="primary"
              mb={3}
              style={{ color: "#5d6858" }}
            >
              -Aubree @ The Realty Influence
            </Typography>
          </Box> */}
          <br></br>
          <br></br>

          <Typography
            variant="h5"
            color="primary"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{
              borderBottom: "1px solid rgba(0,0,0,.125)",
              color: "#5d6858",
            }}
          >
            Client Information
          </Typography>

          <br></br>

          {/* First Name */}
          <Typography
            variant="h6"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            First Name <em style={{ color: "red" }}>*</em>
          </Typography>

          <Form.Item
            name="firstName"
            rules={[
              { required: true, message: "* First Name is required." },
              { min: 3, message: "* Minimum 3 characters required." },
            ]}
            validateStatus={
              touchedFields.firstName && !formValues.firstName
                ? "error"
                : formValues.firstName.length < 3 && touchedFields.firstName
                ? "error"
                : ""
            }
            help={
              touchedFields.firstName && !formValues.firstName
                ? "* First Name is required."
                : formValues.firstName.length < 3 && touchedFields.firstName
                ? "* Minimum 3 characters required."
                : ""
            }
            style={{ width: "100%", marginBottom: "0px" }}
          >
            <Input
              className="custom-input"
              prefix={
                <UserOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                    background: "#4096f",
                  }}
                />
              }
              value={formValues.firstName}
              name="firstName"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          {/* Last Name */}
          <Typography
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            variant="h6"
            style={{
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Last Name <em style={{ color: "red" }}>*</em>
          </Typography>
          <Form.Item
            name="lastName"
            rules={[
              { required: true, message: "* Last Name required." },
              { min: 3, message: "* Minimum 3 characters required." },
            ]}
            validateStatus={
              touchedFields.lastName && !formValues.lastName
                ? "error"
                : formValues.lastName.length < 3 && touchedFields.lastName
                ? "error"
                : ""
            }
            help={
              touchedFields.lastName && !formValues.lastName
                ? "* Last Name is required."
                : formValues.lastName.length < 3 && touchedFields.lastName
                ? "* Minimum 3 characters required."
                : ""
            }
            style={{ width: "100%", marginBottom: "0px" }}
          >
            <Input
              className="custom-input"
              prefix={
                <UserOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                    color: "#4096f",
                  }}
                />
              }
              value={formValues.lastName}
              name="lastName"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          {/* Phone */}
          <Typography
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            variant="h6"
            style={{
              // color: "rgba(0,0,0,.700)",
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Phone <em style={{ color: "red" }}>*</em>
          </Typography>
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: "* Phone number required." },
              { min: 10, message: "* Minimum 10 characters required." },
            ]}
            validateStatus={
              touchedFields.phone && !formValues.phone
                ? "error"
                : formValues.phone.length < 10 && touchedFields.phone
                ? "error"
                : ""
            }
            help={
              touchedFields.phone && !formValues.phone
                ? "* Phone number required."
                : formValues.phone.length < 10 && touchedFields.phone
                ? "* Minimum 10 characters required."
                : ""
            }
            style={{ width: "100%", marginBottom: "0px" }}
          >
            <Input
              className="custom-input"
              prefix={
                <PhoneOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                    transform: "rotate(90deg)",
                  }}
                />
              }
              value={formValues.phone}
              name="phone"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          {/* Email */}
          <Typography
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            variant="h6"
            style={{
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Email <em style={{ color: "red" }}>*</em>
          </Typography>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "* Email is required." },
              {
                pattern:
                  /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]{3,}\.[a-zA-Z]{2,}$/,
                message: "* Enter a valid email address",
              },
            ]}
            validateStatus={
              touchedFields.email &&
              (!formValues.email
                ? "error"
                : !/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]{3,}\.[a-zA-Z]{2,}$/.test(
                    formValues.email
                  )
                ? "error"
                : "")
            }
            help={
              touchedFields.email &&
              (!formValues.email
                ? "* Email is required."
                : !/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]{3,}\.[a-zA-Z]{2,}$/.test(
                    formValues.email
                  )
                ? "* Enter a valid email address with at least 3 characters before and after '@', and after '.'."
                : "")
            }
            style={{ width: "100%", marginBottom: "0px" }}
          >
            <Input
              className="custom-input"
              prefix={
                <MailOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                  }}
                />
              }
              value={formValues.email}
              name="email"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          <Typography
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            variant="h6"
            style={{
              // color: "rgba(0,0,0,.700)",
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Desired Location <em style={{ color: "red" }}>*</em>
          </Typography>
          <Typography
            variant="h8"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{ color: "rgba(0,0,0,.500)" }}
          >
            {lastSegment === "DFW"
              ? `i.e. Addison, Uptown, Frisco, Plano, etc. Within 30 minutes of your job. Not sure on location? I can help! Just tell me what you’re looking for in your new neighborhood!`
              : `i.e. South Lamar, South Austin, Mueller, etc. Within 30 minutes of your job. Not sure on location? I can help! Just tell me what you’re looking for in your new neighborhood!`}
          </Typography>
          <Form.Item
            style={{ marginBottom: 0, marginTop: "10px" }}
            validateStatus={
              touchedFields.desired_location && !formValues.desired_location
                ? "error"
                : touchedFields.desired_location &&
                  formValues.desired_location.length < 3
                ? "error"
                : ""
            }
            help={
              touchedFields.desired_location && !formValues.desired_location
                ? "* Desired Location required."
                : touchedFields.desired_location &&
                  formValues.desired_location.length < 3
                ? "Minimum 3 characters required."
                : ""
            }
          >
            <TextArea
              className="custom-input-area"
              rows={4}
              value={formValues.desired_location}
              name="desired_location"
              onChange={handleChange}
              autoComplete="off"
              style={{
                width: "100%",
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>
          {/* Number of Bedrooms */}
          <FormControl fullWidth required>
            <Typography
              sx={{ fontFamily: "'Playfair Display', serif !important" }}
              variant="h6"
              style={{
                // color: "rgba(0,0,0,.700)",
                marginBottom: "2px",
                marginTop: "5px",
              }}
            >
              Unit Size <em style={{ color: "red" }}>*</em>
            </Typography>
            <FormGroup>
              {bedrooms.map((bedroom, index) => (
                <FormControlLabel
                  className="custom-check-box"
                  key={index}
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: isMobile ? "1rem" : "1rem", // Checkbox size
                        },
                        // fontFamily: "'Montserrat', sans-serif !important"
                      }}
                      checked={formValues.bedrooms.includes(bedroom)} // Check if the bedroom is selected
                      onChange={(e) => {
                        // Handle adding/removing the bedroom from the array
                        const newBedrooms = e.target.checked
                          ? [...formValues.bedrooms, bedroom] // Add to selection
                          : formValues.bedrooms.filter((b) => b !== bedroom); // Remove from selection
                        handleChange({
                          target: {
                            name: "bedrooms",
                            value: newBedrooms,
                          },
                        });
                      }}
                    />
                  }
                  label={bedroom}
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: isMobile ? "1rem" : "1rem", // Label text size
                    },
                  }}
                />
              ))}
            </FormGroup>
            {touchedFields.bedrooms && formValues.bedrooms.length === 0 && (
              <Typography
                variant="caption"
                color="error"
                sx={{ fontSize: isMobile ? "14px" : "14px" }}
              >
                * Unit size required.
              </Typography>
            )}
          </FormControl>

          {/* Budget */}
          <Typography
            variant="h6"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{
              // color: "rgba(0,0,0,.700)",
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Max Budget <em style={{ color: "red" }}>*</em>
          </Typography>
          <Form.Item
            name="budget"
            rules={[{ required: true, message: "* Budget required." }]}
            validateStatus={
              touchedFields.budget && !formValues.budget ? "error" : ""
            }
            help={
              touchedFields.budget && !formValues.budget
                ? "* Budget required."
                : ""
            }
            style={{ width: "100%", marginBottom: "0px" }}
          >
            <Input
              className="custom-input"
              prefix={
                <DollarOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                  }}
                />
              }
              min={0}
              type="number"
              value={formValues.budget}
              name="budget"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          {/* Move in Month */}
          <Typography
            variant="h6"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            Move in Date <em style={{ color: "red" }}>*</em>
          </Typography>

          <Form.Item
            validateStatus={
              touchedFields.month && !formValues.month ? "error" : ""
            }
            help={
              touchedFields.month && !formValues.month
                ? "* Move in Date required."
                : ""
            }
          >
            <Input
              className="custom-input"
              type="date"
              prefix={
                <CalendarOutlined
                  style={{
                    fontSize: isMobile ? "1rem" : "1rem",
                    borderRadius: "30%",
                    backgroundColor: "transparent",
                    padding: isMobile ? "4px" : "8px",
                  }}
                />
              }
              value={formValues.month}
              name="month"
              onChange={handleChange}
              autoComplete="off"
              style={{
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          <Typography
            variant="h6"
            sx={{ fontFamily: "'Playfair Display', serif !important" }}
            style={{
              marginBottom: "2px",
              marginTop: "5px",
            }}
          >
            What else would you like to tell me? The more I know, the
            better!&nbsp;<em style={{ color: "red" }}>*</em>{" "}
          </Typography>
          <Typography variant="h8" style={{ color: "rgba(0,0,0,.500)" }}>
            {/* Are there any specific features you’d like to have in your new home?
           Any credit or background concerns? Any other details
            you’d like me to know while looking for your new home? */}
             Are there any specific features you’d like to have in your new home? 
             Any credit issues, background concerns, evictions, or broken leases? Any other details 
             you’d like me to know while looking for your new home?
          </Typography>
          <Form.Item
            style={{ marginBottom: 0, marginTop: "10px" }}
            validateStatus={
              touchedFields.additional_notes && !formValues.additional_notes
                ? "error"
                : touchedFields.additional_notes &&
                  formValues.additional_notes.length < 3
                ? "error"
                : ""
            }
            help={
              touchedFields.additional_notes && !formValues.additional_notes
                ? "* Field is required."
                : touchedFields.additional_notes &&
                  formValues.additional_notes.length < 3
                ? "Minimum 3 characters required."
                : ""
            }
          >
            <TextArea
              className="custom-input-area"
              rows={4}
              value={formValues.additional_notes}
              name="additional_notes"
              onChange={handleChange}
              autoComplete="off"
              style={{
                width: "100%",
                fontSize: isMobile ? "1rem" : "1rem",
                padding: isMobile ? "12px" : "10px",
                borderRadius: "20px",
              }}
            />
          </Form.Item>

          {/* Submit Button */}
          <Grid
            container
            spacing={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              width: "100%",
              marginLeft: "0px",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              sx={{
                height: "50px",
                width: "50%",
                borderRadius: "20px",
                backgroundColor: loading ? "gray" : undefined, // Change to gray when loading
                color: loading ? "white" : undefined, // Adjust text color if needed
              }}
              // disabled={!isFormValid}
              disabled={loading}
            >
              {loading ? "Please Wait..." : "Submit"}
            </Button>
          </Grid>
        </Grid>
        <Modal open={modalLoader}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress disableShrink />
              </div>
            </div>
          </Box>
        </Modal>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
        />
      </form>
    </div>
  );
};

export default AddClient;
